import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MegaMenu extends ThemeComponent {
    @Ref({required: false}) dropdown!: HTMLElement[];

    /**
     * Initialise.
     */
    init() {
        if (window.quickLaunch.megaMenu) {
            this.handleMagaMenu();
        }
        const highlights = document.querySelectorAll('.site-header__highlight');
        for (const highlight of highlights ){
            if (highlights.length > 3) {
                highlight.classList.add('site-header__highlight--extended');
            }
        }
    }

    /**
     * Handle mega menu.
     */
    handleMagaMenu() {
        for(const dropdown of this.dropdown) {
            dropdown?.classList.add('site-header__dropdown--mega');
        }
    }
}
